module.exports = __webpack_public_path__ + "mainassets/img/rule_2.b7949773.jpg";